import useAuth from 'hooks/useAuth';
import { useQuery } from 'react-query';
import { Note } from 'types/note';

export default function usePatientSessionNotes(therapistId: string | null | undefined, patientId: string | null | undefined) {
  const url = `/therapists/${patientId}/noteInfo`;
  const { request } = useAuth();

  const { data: notes, refetch: refetchNotes } = useQuery(
    url,
    () => request.get(url).then((response) => response.data.sessions.map((note) => ({ ...note, id: note._id })) as Note[]),
    { enabled: !!therapistId && !!patientId }
  );

  return { notes, refetchNotes };
}
